import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {conceptsActionTypes, LoadConceptsSuccessAction} from '../actions/concept';
import {Concept} from '../models/concept';

export interface ConceptsState {
  array: Concept[];
}

const initialState: ConceptsState = {
  array: []
};

export function ConceptsReducer(state: ConceptsState = initialState, action: Action): ConceptsState {
  switch (action.type) {
    case conceptsActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case conceptsActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ConceptsState, action: LoadConceptsSuccessAction): ConceptsState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}



function handleLoadFailAction(state: ConceptsState): ConceptsState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}
function handleLoadClearAction(state: ConceptsState): ConceptsState {
  return initialState;
}

export const conceptsSelectors = {
  array: (state: ConceptsState) => _.get(state, 'array', [])
};
